/* global EventSource */
import { React, connect, fetchApi } from '@gasbuddy/react';
import { Dimmer, Loader, Select, Segment, Button, Form, Divider } from 'semantic-ui-react';
import { ActionGroups } from '../../roles';
import { Auth, Nav } from '../../components';

const Types = [{
  text: 'Encrypted User Ids',
  value: 'encId',
}, {
  text: 'Email Addresses',
  value: 'email',
}, {
  text: 'Account Ids/Guids (in Account Id field)',
  value: 'accountId',
}, {
  text: 'Fulfillment Ids',
  value: 'fulfillmentId',
}, {
  text: 'Wex Card Numbers',
  value: 'wexCard',
}, {
  text: 'Roadside Id',
  value: 'roadside',
}, {
  text: 'Audible Code',
  value: 'audible',
}, {
  text: 'Rewards Network PPN',
  value: 'rewardsNetworkPpn',
}, {
  text: 'Account ID to RN PPN',
  value: 'accountIdToRnPpn',
}];

class BaseLookupPage extends React.Component {
  state = {
    type: 'encId',
  }

  componentWillUnmount() {
    if (this.sse) {
      this.sse.close();
      delete this.sse;
    }
  }

  go = (e) => {
    e.preventDefault();
    const { inputs, outputs: accountIds, type } = this.state;
    this.setState({ loading: true, outputs: '' }, async () => {
      const { body: { id } } = await fetchApi({
        url: '/identity/lookup/start',
        body: { inputs: type === 'accountId' ? accountIds : inputs, type },
      });
      if (this.sse) {
        this.sse.close();
      }
      let outputs = [];
      let failures = [];
      this.sse = new EventSource(
        `/identity/lookup/stream/${id}`,
        { withCredentials: true },
      );
      this.sse.onmessage = (sseData) => {
        const data = JSON.parse(sseData.data);
        if (data.length === 0) {
          this.sse.close();
          delete this.sse;
          this.setState({ loading: false });
        }
        outputs = [...outputs, ...data[0]];
        failures = [...failures, ...data[1]];
        if (type === 'accountId') {
          this.setState({ inputs: outputs.join('\n') });
          this.setState({ outputs: failures.join('\n') });
        } else {
          this.setState({ outputs: outputs.join('\n') });
          this.setState({ inputs: failures.join('\n') });
        }
      };
    });
  }

  render() {
    const { inputs, outputs, loading } = this.state;
    return (
      <Auth
        forActions={ActionGroups.Users}
      >
        <Nav>
          <Dimmer.Dimmable as={Segment} dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <div>
              <h1>Bulk Account Lookup</h1>
              <Form onSubmit={this.go}>
                <Form.Group>
                  <Select
                    style={{ minWidth: 250 }}
                    options={Types.map(t => ({ value: t.value, text: t.text }))}
                    placeholder="Select input format"
                    onChange={(e, selection) => this.setState({ type: selection.value })}
                  />
                  &nbsp;
                  <Button>Go</Button>
                </Form.Group>
                <Divider />
                <Form.Group widths="equal">
                  <Form.TextArea
                    rows={30}
                    value={inputs}
                    onChange={e => this.setState({ inputs: e.target.value })}
                    label="Input values"
                    placeholder="Enter one identifier per line..."
                  />
                  <Form.TextArea
                    rows={30}
                    value={outputs}
                    onChange={e => this.setState({ outputs: e.target.value })}
                    label="Account Ids"
                    placeholder="Translated ids will appear here"
                  />
                </Form.Group>
              </Form>
            </div>
          </Dimmer.Dimmable>
        </Nav>
      </Auth>
    );
  }
}

export const LookupPage = connect(({ api }) => ({ api }))(BaseLookupPage);
